import { createApp } from 'vue'
import App from './App.vue'

import '@/1-styles/tailwind.css'

createApp( App ).mount( '#app' )
